import {Component, Host, Input, OnInit} from '@angular/core';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';
import {ChatWrapperComponent} from '../chat-wrapper/item';
import {HelperService} from 'app/services/helper.service';

// @todo chat move common to abstract class
@Component({
  selector: 'app-chat-date-message',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatDateMessageComponent implements OnInit {
  protected readonly HelperService = HelperService;
  @Input() previousMessage: Message = null;
  @Input() message: Message = null;
  chatWrapper: ChatWrapperComponent;

  constructor(
    @Host() chatWrapper: ChatWrapperComponent
  ) {
    this.chatWrapper = chatWrapper;
  }

  ngOnInit() {

  }

  isNewDay() {
    // @todo chat remove after back fix
    if (typeof this.previousMessage === 'undefined') {
      return false;
    }
    if (!(!!this.message.state?.getCreateState() && !!this.previousMessage.state?.getCreateState())) {
      return false;
    }

    return !(
      this.previousMessage &&
      HelperService.convertDateToCustomDate(this.message.state.getCreateState()?.date).format('MM.yyyy.dd') === HelperService.convertDateToCustomDate(this.previousMessage.state.getCreateState().date).format('MM.yyyy.dd')
    );
  }

  isNewYear() {
    // @todo chat remove after back fix
    if (typeof this.previousMessage === 'undefined') {
      return false;
    }
    if (!(!!this.message.state?.getCreateState() && !!this.previousMessage.state?.getCreateState())) {
      return false;
    }

    return !(
      this.previousMessage &&
      HelperService.convertDateToCustomDate(this.message.state.getCreateState()?.date).format('yyyy') === HelperService.convertDateToCustomDate(this.previousMessage.state.getCreateState().date).format('yyyy')
    );
  }
}
